import { Navigate, Route, Routes } from 'react-router-dom';
import { ManageAccessApp } from './pages/access/manage-access-app';
import { LoginApp } from './pages/account/login/login-app';
import { Logout } from './pages/account/logout';
import { RegisterApp } from './pages/account/register/register-app';
import { UserProfileApp } from './pages/account/user-profile/user-profile-app';
import { BoardApp } from './pages/admin/board-page/board-app';
import { ContractApp } from './pages/admin/contract-page/contract-app';
import { CustomerApp } from './pages/admin/customer-page/customer-app';
import { SettingApp } from './pages/admin/setting-page/setting-app';
import { UserLogApp } from './pages/admin/user-log-page/user-log-app';
import { HomeApp } from './pages/home/dashboard/home-app';
import { NotFound } from './pages/shared/not-found';
import { Protected } from './pages/shared/protected';
import { PublicLayout } from './pages/shared/public-layout';

export const AppRoutes = () => {
    return (
        <Routes>
            <Route element={<PublicLayout />}>
                <Route element={<Protected />}>
                    <Route path="/home" element={<HomeApp />} />

                    {/* admin */}
                    <Route path="/admin/manage-users" element={<ManageAccessApp />} />
                    <Route path="/admin/contract" element={<ContractApp />} />
                    <Route path="/admin/board" element={<BoardApp />} />
                    <Route path="/admin/customer" element={<CustomerApp />} />
                    <Route path="/admin/setting" element={<SettingApp />} />
                    <Route path="/admin/user-log" element={<UserLogApp />} />
                    <Route
                        path="/admin/access-role"
                        element={<ManageAccessApp selectedTab="role-teams" />}
                    />
                    <Route
                        path="/admin/manage-users"
                        element={<ManageAccessApp selectedTab="users" />}
                    />
                    <Route path="/profile" element={<UserProfileApp />} />

                    {/* admin */}
                </Route>
            </Route>
            <Route path="/" element={<PublicLayout />}>
                <Route path="/" element={<Navigate to="/home" />} />
                <Route path="/login" element={<LoginApp />} />
                <Route path="/register" element={<RegisterApp />} />
                <Route path="/logout" element={<Logout />} />
                <Route path="*" element={<NotFound />} />
            </Route>
        </Routes>
    );
};
